import { createBrowserRouter, createRoutesFromElements } from 'react-router-dom'

import ProtectRouter from './ProtectRouter'
import PublicRouter from './PublicRouter'

export default createBrowserRouter(
  createRoutesFromElements([PublicRouter, ProtectRouter]),
)
